import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Button } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import useSharedAppsBaseUrl from '../../hooks/useSharedAppsBaseUrl';
import { leadClientURLsMap, DEALER_CODE } from '../../utils/constants';
import themeStyles from './DealerCard.style';
import useIsCrossOrigin from '../../hooks/useIsCrossOrigin';

const SecondaryButton = themeStyles.apply(Button, 'SecondaryButton');

const createSearchParams = (queryParams, dealerCode) => {
  const params = new URLSearchParams(queryParams);
  params.delete(DEALER_CODE);
  params.set(DEALER_CODE, dealerCode);
  return params.toString();
};
const SelectDealerButton = ({ dealerCode, urlParams, handleClick }) => {
  const { t } = useTranslation();
  const { currentURLName, queryParams } = urlParams;
  const leadClientBaseUrl = useSharedAppsBaseUrl(leadClientURLsMap[currentURLName]);

  const buttonHref = useMemo(() => {
    const searchParams = createSearchParams(queryParams, dealerCode);
    return `${leadClientBaseUrl}?${searchParams}`;
  }, [leadClientBaseUrl, queryParams, dealerCode]);

  const isCrossOrigin = useIsCrossOrigin(buttonHref);

  return (
    <SecondaryButton
      as="a"
      href={buttonHref}
      data-testid="cy-select-dealer-cta"
      styling="primary"
      onClick={handleClick}
      rel={isCrossOrigin ? 'noreferrer noopener' : undefined}
    >
      {t('Sub-apps.Dealers.selectThisDealerButton')}
    </SecondaryButton>
  );
};

SelectDealerButton.propTypes = {
  dealerCode: PropTypes.string,
  urlParams: PropTypes.shape({
    queryParams: PropTypes.string,
    currentURLName: PropTypes.string.isRequired,
  }),
  handleClick: PropTypes.func,
};

export default SelectDealerButton;
